import type { KnownChat } from '@/components/KnownChatsModal';

export function knownChatLabel(chat: KnownChat): string {
  if (chat.username) return `@${chat.username.replace(/^@/, '')}`;
  if (chat.first_name) return chat.first_name;
  return String(chat.chat_id);
}

export function knownChatSourceLabel(source: string | null | undefined): string {
  if (!source) return '—';
  if (source.toLowerCase().includes('telethon')) return 'Telethon';
  if (source.toLowerCase().includes('bot')) return 'Bot';
  return source;
}

export function knownChatEntityLabel(entityType: string | null | undefined): string {
  if (!entityType) return '—';
  const normalized = entityType.toLowerCase();
  if (normalized === 'user') return 'User';
  if (normalized === 'channel') return 'Channel';
  if (normalized === 'chat') return 'Group';
  if (normalized === 'supergroup') return 'Group';
  if (normalized === 'bot') return 'Bot';
  return entityType.charAt(0).toUpperCase() + entityType.slice(1);
}

export function knownChatRowSearchValue(chat: KnownChat): string {
  return [
    String(chat.chat_id),
    chat.username ?? '',
    chat.first_name ?? '',
    knownChatSourceLabel(chat.source),
    knownChatEntityLabel(chat.entity_type),
  ]
    .join(' ')
    .trim();
}

export function filterKnownChats(chats: KnownChat[], query: string): KnownChat[] {
  const q = query.trim().toLowerCase();
  if (!q) return chats;
  return chats.filter((chat) => knownChatRowSearchValue(chat).toLowerCase().includes(q));
}
